import { type ComponentPublicInstance, getCurrentInstance } from 'vue';

import type { CookieConsentInstance } from '@/shims-vue';

export function useCookieConsent() {
  const getCookieConsentInstance = (): CookieConsentInstance => {
    const instance = getCurrentInstance();
    if (!instance?.proxy) {
      throw new Error('Cookie consent instance not available');
    }
    return (instance.proxy as ComponentPublicInstance).$cc;
  };

  const exposeCookieConsentToWindow = () => {
    if (typeof window !== 'undefined') {
      window.cc = getCookieConsentInstance();
    }
  };

  return {
    getCookieConsentInstance,
    exposeCookieConsentToWindow,
  };
}
